export enum UserRole {
  DEVELOPER = 'developer',
  ADMINISTRATOR = 'admin',
  AGENT = 'agent',
  AUDITOR = 'auditor',
  DOCTOR = 'doctor'
}
